import React,{Component} from 'react';			

export default class ThemeButton extends Component{
	render(){
		return(
			<>
				<a href="http://whitebing.com" className="bt-buy-now theme-btn"><i className="ti-comments"></i><span>Chat Now</span></a>
				<a href="mailto:support@whitebing.com"  className="bt-support-now theme-btn"><i className="ti-headphone-alt"></i><span>Support</span></a>
			</>
		)
	}	
}
